"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var getLabelID = function getLabelID(label, size, isTest) {
  return isTest ? "id0" : "".concat(label.toString().toLowerCase().split(" ").join("-"), "--").concat(size || 0);
};

var InlineSVG = function InlineSVG(_ref) {
  var icon = _ref.icon,
      size = _ref.size,
      label = _ref.label,
      _ref$isTest = _ref.isTest,
      isTest = _ref$isTest === void 0 ? false : _ref$isTest,
      rest = _objectWithoutProperties(_ref, ["icon", "size", "label", "isTest"]);

  var labelID = label || "";
  var titleID = labelID && getLabelID(labelID, size, isTest);
  var width = size ? "width=\"".concat(size, "\"") : "";
  var height = size ? "height=\"".concat(size, "\"") : "";
  var a11yTitleTag = label ? "<title id=".concat(titleID, ">Icon - ").concat(label, "</title") : "<title></title";
  var comp = icon.replace(/<svg([^>]*)/g, "<svg role=\"img\" ".concat(width, " ").concat(height, " aria-labelledby=\"").concat(titleID, "\" $1>").concat(a11yTitleTag));
  return _react.default.createElement("span", _extends({
    dangerouslySetInnerHTML: {
      __html: comp
    }
  }, rest));
};

InlineSVG.propTypes = {
  icon: _propTypes.string.isRequired,
  size: _propTypes.number,
  label: _propTypes.string,
  isTest: _propTypes.bool
};
InlineSVG.defaultProps = {
  size: null,
  label: "",
  isTest: false
};
var _default = InlineSVG;
exports.default = _default;